module.exports = __webpack_public_path__ + "static/assets/f0964e72f44ce4c6396414b7540ad3a0.gif";